import { homeConstants } from "../constants";
import {
  fileService,
  documentService,
  dashboardService,
  homeService,
} from "../services";
import { loaderMaskActions } from ".";
import { handleErrors } from "../../utils";
import moment from "moment";

export const homeActions = {
  getFilesBucketsStates,
  get24HFileSammary,
  get7DFileSammary,

  getLast5IncomingFiles,

  getFilteredFiles,
  getFilteredDocs,
  getFilteredDocsByReceiver,
  getFilteredDocsbyEBID,
  clearFilters,
};

function clearFilters() {
  return { type: homeConstants.CLEAR_FILTERS };
}

function getFilteredFiles(params) {
  return (dispatch) => {
    dispatch(request());
    fileService.getAll(params).then(
      (data) => {
        dispatch(success(data.Data, data.TotalCount > 2));
      },
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: homeConstants.GET_FILES_REQUEST };
  }

  function success(data, showMore) {
    return { type: homeConstants.GET_FILES_SUCCESS, data, showMore };
  }

  function failure(error) {
    return { type: homeConstants.GET_FILES_FAILURE, error };
  }
}

function getFilteredDocs(params, sessionId) {
  return (dispatch) => {
    dispatch(request());
    documentService.getAll(params).then(
      (data) => {
        if (sessionId === window.__sessionId) {
          dispatch(
            success(data.Data.documents, data.TotalCount > 2, sessionId)
          );
        }
      },
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: homeConstants.GET_DOCS_REQUEST };
  }

  function success(data, showMore, sId) {
    return { type: homeConstants.GET_DOCS_SUCCESS, data, showMore, sId };
  }

  function failure(error) {
    return { type: homeConstants.GET_DOCS_FAILURE, error };
  }
}

function getFilteredDocsByReceiver(params, sessionId) {
  return (dispatch) => {
    dispatch(request());
    documentService.getAll(params).then(
      (data) => {
        if (sessionId === window.__sessionId2) {
          dispatch(
            success(data.Data.documents, data.TotalCount > 2, sessionId)
          );
        }
      },
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: homeConstants.GET_DOCS_BY_RECEIVER_REQUEST };
  }

  function success(data, showMore, sId) {
    return { type: homeConstants.GET_DOCS_BY_RECEIVER_SUCCESS, data, showMore, sId };
  }

  function failure(error) {
    return { type: homeConstants.GET_DOCS_FAILURE, error };
  }
}

function getFilteredDocsbyEBID(params) {
  return (dispatch) => {
    dispatch(request());
    documentService.getAll(params).then(
      (data) => {
        dispatch(success(data.Data.documents, data.TotalCount > 2));
      },
      (error) => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: homeConstants.GET_DOCS_EBID_REQUEST };
  }

  function success(data, showMore) {
    return { type: homeConstants.GET_DOCS_EBID_SUCCESS, data, showMore };
  }

  function failure(error) {
    return { type: homeConstants.GET_DOCS_FAILURE, error };
  }
}

function getFilesBucketsStates(customerId) {
  return (dispatch) => {
    dispatch(loaderMaskActions.show("Loading States..."));
    dispatch(request());
    var params = {
      CustomerId: customerId,
      IsExternal: true,
    };
    homeService.getFilesBucketsStates(params).then(
      (data) => {
        const {
          filesCount24h,
          filesCount7d,
          incommingDocsCount24h,
          incommingDocsCount7d,
          filesCount24hTest,
          filesCount7dTest,
          incommingDocsCount24hTest,
          incommingDocsCount7dTest,
          files,
          channelsStats7d,
          channelsStats24h,
        } = data.Data;
        dispatch(loaderMaskActions.hide(""));
        dispatch(
          success(
            filesCount24h,
            filesCount7d,
            incommingDocsCount24h,
            incommingDocsCount7d,
            filesCount24hTest,
            filesCount7dTest,
            incommingDocsCount24hTest,
            incommingDocsCount7dTest,
            files,
            channelsStats7d,
            channelsStats24h
          )
        );
      },
      (error) => {
        //handleErrors(error, dispatch);
        dispatch(loaderMaskActions.hide(""));
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: homeConstants.GETALL_REQUEST };
  }

  function success(
    filesCount24h,
    filesCount7d,
    incommingDocsCount24h,
    incommingDocsCount7d,
    filesCount24hTest,
    filesCount7dTest,
    incommingDocsCount24hTest,
    incommingDocsCount7dTest,
    files,
    channelsStats7d,
    channelsStats24h
  ) {
    return {
      type: homeConstants.GET_FILES_BUCKETS_STATES_SUCCESS,
      filesCount24h,
      filesCount7d,
      incommingDocsCount24h,
      incommingDocsCount7d,
      filesCount24hTest,
      filesCount7dTest,
      incommingDocsCount24hTest,
      incommingDocsCount7dTest,
      files,
      channelsStats7d,
      channelsStats24h
    };
  }

  function failure(error) {
    return { type: homeConstants.GETALL_FAILURE, error };
  }
}

function get24HFileSammary(customerId) {
  return (dispatch) => {
    //dispatch(request());
    var _to = new Date(),
      _from = new Date();
    _from.setDate(_from.getDate() - 1);
    let params = {
      Start: moment.utc(_to).format("YYYY-MM-DDTHH:mm:ss.SSS"),
      End: moment.utc(_from).format("YYYY-MM-DDTHH:mm:ss.SSS"),
      CustomerId: customerId,
      WidgetId: "WidgetFileCountPieChart",
    };
    dashboardService.getWedgetData(params).then(
      (wData) => {
        var value = 0;
        if (wData.Data && wData.Data.length) {
          value = wData.Data[0].value;
        }
        dispatch(success(value));
      },
      (error) => {
        //handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function success(count) {
    return { type: homeConstants.GET_24H_FILE_SAMMARY_SUCCESS, count };
  }

  function failure(error) {
    return { type: homeConstants.GETALL_FAILURE, error };
  }
}

function get7DFileSammary(customerId) {
  return (dispatch) => {
    //dispatch(request());
    var _to = new Date(),
      _from = new Date();
    _from.setDate(_from.getDate() - 7);
    let params = {
      Start: moment.utc(_to).format("YYYY-MM-DDTHH:mm:ss.SSS"),
      End: moment.utc(_from).format("YYYY-MM-DDTHH:mm:ss.SSS"),
      CustomerId: customerId,
      WidgetId: "WidgetFileCountPieChart",
    };
    dashboardService.getWedgetData(params).then(
      (wData) => {
        var value = 0;
        if (wData.Data && wData.Data.length) {
          value = wData.Data[0].value;
        }
        dispatch(success(value));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function success(count) {
    return { type: homeConstants.GET_7D_FILE_SAMMARY_SUCCESS, count };
  }

  function failure(error) {
    return { type: homeConstants.GETALL_FAILURE, error };
  }
}

function getLast5IncomingFiles(customerId) {
  return (dispatch) => {
    //dispatch(loaderMaskActions.show('Loading reports...'));
    //dispatch(request(params.WidgetId, params.Granularity));
    var params = {
      PageNumber: 1,
      Size: 5,
    };
    fileService.getAll(params).then(
      (data) => {
        dispatch(success(data.Data));
      },
      (error) => {
        //handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function success(data) {
    return { type: homeConstants.GET_LAST_5_INCOMING_FILES_SUCCESS, data };
  }

  function failure(error) {
    return { type: homeConstants.GETALL_FAILURE, error };
  }
}
